import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  eventScheduleContainer: {
    height: '20vh',
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      // height: '33.8vh',
    },
  },
  eventScheduleContainerMobile: {
    height: '23vh',
  },
  alumniCreateSurveyContainerTitleBorder: {
    background: 'linear-gradient(90deg, #BFCEFF 0%, #BFCEFF00 100%);',
    height: '1px',
    marginTop: '4px'
  },
  horizontalLine: {
    height: '58vh',
    backgroundColor: '#E5E6EA',
    width: '1px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh !important',
    },
  },
  noEvent: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    height: 'auto !important',
    minHeight: '150px',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    flex: 1,
  },
  mobileSessionCard: {
    borderRadius: '16px',
    background: '#E8EBF3',
    marginBottom: '0px',
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
  },
  mobileSessionExpanded: {
    borderRadius: '16px',
    background: '#E8EBF3',
    marginTop: '0px',
    marginBottom: '16px',
    padding: '16px',
  },
  noEventImage: {
    height: '20vh',
    width: '20vw',
    objectFit: 'contain',
    margin: '3% auto',
  },
  filterBtn: {
    background: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '0.8rem !important',
    padding: '6px 20px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem !important',
      padding: '2px 14px !important',
      borderRadius: '6px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '6px 15px !important',
      fontSize: '10px !important',
    },
  },
  eventCardLayout: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    height: '100%',
    backgroundSize: 'cover !important',
    backgroundPosition: 'center !important',
    borderRadius: '12px',
    padding: '10px 8px',
    '@media (min-width: 200px) and (max-width: 600px)': {
      padding: '0px',
    },
  },
  
  eventCardContent: {
    position: 'relative',
    zIndex: 2,
    marginTop: 'auto',
    paddingBottom: '10px',
  },
  noPhotoPlaceholder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    position: 'relative',
    zIndex: 2,
  },
  noPhotoText: {
    color: '#666 !important',
    fontSize: '18px !important',
    fontWeight: '600 !important',
    textAlign: 'center',
    lineHeight: '1.2 !important',
    '@media (max-width: 1440px)': {
      fontSize: '16px !important',
    },
    '@media (max-width: 1280px)': {
      fontSize: '14px !important',
    },
  },
  eventCard: {
    height: '336px',
    borderRadius: '12px !important',
    textAlign: 'start',
    width: '100%',
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: '#f5f5f5',
    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '35vh !important',
    },
    '@media (min-width: 400px) and (max-width: 600px)': {
      height: '30vh !important',
    },
    '@media (max-width: 1440px)': {
      height: '252px',
    },
    '@media (max-width: 1280px)': {
      height: '35vh',
    },
    '@media (max-width: 1536px)': {
      height: '35vh',
    },
  },
  registeredEvents: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '4px',
    margin: '10px 0px',
    background: `${theme.palette.KenColors.ClientBlue} !important`,
    boxShadow: 'none !important',
    padding: '12px',
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    borderLeft: `4px solid #0B3E69`,
    textAlign: 'start',
    cursor: 'pointer',
    '@media (max-width: 1440px)': {
      padding: '9px',
    },
  },
  registeredEventsBanner: {
    height: '70px',
    width: '70px',
    objectFit: 'cover',
    borderRadius: '4px',
    '@media (max-width: 1440px)': {
      height: '63px',
      width: '63px',
    },
  },
  registerEventCategory: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    zIndex: 2,
    paddingTop: '10px',
  },
  cardTag: {
    fontSize: '0.7rem',
    fontWeight: '600 !important',
    backgroundColor: theme.palette.KenColors.kenWhite,
    color: theme.palette.KenColors.ClientBlack2,
    position: 'relative',
    zIndex: 2,
    '@media (max-width: 1440px)': {
      fontSize: '0.6rem !important',
    },
  },
  cardHeader: {
    color: theme.palette.KenColors.kenWhite,
    fontSize: '0.9rem !important',
    fontWeight: '600 !important',
    textTransform: 'capitalize',
    margin: '4px 0px !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11px !important',
    },
  },
  description: {
    color: theme.palette.KenColors.kenWhite,
    fontSize: '0.75rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.7rem !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  cardActionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0px',
    margin: '8px auto',
    position: 'relative',
    zIndex: 2,
  },
  cardContainer: {
    background: 'transparent',
    padding: '20px 20px 20px 20px !important',
    boxShadow: 'none !important',
    height: '83.5vh',
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: '35vh !important',
    },
    '@media (min-width: 1200px) and (max-width: 1436px)': {
      height: '81vh !important',
    },
    borderRadius: '9px !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  cardContainerMobile: {
    background: 'transparent',
    padding: '20px 20px 20px 20px !important',
    boxShadow: 'none !important',
    height: '35',
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: '35vh !important',
    },
    borderRadius: '9px !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  cardHolder: {
    marginTop: '25px',
    boxShadow: 'none !important',
    width: '100% !important',
    [theme.breakpoints.down('md')]: {
      marginTop: '50px',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px !important',  
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px !important',  
    },
  },
  hostEventCard: {
    background: `${theme.palette.KenColors.ClientBlue3} !important`,
    padding: '10px 16px',
    borderRadius: '12px !important',
  },
  registerEventsContainer: {
    padding: '0px 22px',
    height: 'auto',
    minHeight: '200px',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxShadow: 'none !important',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('xxl')]: {
      minHeight: '300px',
    },
    '@media (max-width: 1536px)': {
      minHeight: '250px',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      minHeight: '350px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      minHeight: '150px',
    },
  },
  tabEvent: {
    height: '71.5vh',
    [theme.breakpoints.up('xxl')]: {
      height: '75.5vh',
    },
    '@media (max-width: 1600px)': {
      height: '72vh',
    },
  },
  eventDetailsCard: {
    height: '80vh',
    [theme.breakpoints.up('xxl')]: {
      height: '80vh',
    },
    display: "block !important"
  },
  registeredEventsHeading: {
    textAlign: 'start',
    fontSize: '15px !important',
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '550 !important',
    margin: '2px 2px 17px 5px !important',
    '@media (min-width: 280px) and (max-width: 600px)': {
      margin: '2px 2px 0px 5px !important',
    },
    '@media (max-width: 1440px)': {
      fontSize: '15px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  hostEventHeading: {
    textAlign: 'start',
    fontSize: '14px !important',
    color: theme.palette.KenColors.kenWhite,
    fontWeight: '500 !important',
  },
  cellsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px !important',
    rowGap: '8px !important',
    flexWrap: 'wrap',
  },
  hostAnEventBanner: {
    height: '120px',
    width: 'auto',
    margin: '20px 0px',
  },
  paperCustom: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    padding: '20px',
    overflow: 'hidden',
    borderRadius: '9px !important',
    width: '100%',
  },
  paperCustomMobileMain: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    padding: '20px',
    borderRadius: '9px !important',
    width: '100%',
    height: '80vh',
    overflow: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.KenColors.ClientBlue8} transparent`,
  },
  paperCustomMobile: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    // padding: '20px',
    overflow: 'hidden',
    borderRadius: '9px !important',
    width: '100%',
  },
  accordionSummaryCustom: {
    '& > .MuiAccordionSummary-content': {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center',
      borderRadius: '8px !important',
    },
  },
  accordionContainer: {
    // height: '20vh',
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  eventBanner: {
    backgroundPosition: 'center !important',
    backgroundSize: 'cover !important',
    height: '246px',
    width: 'auto',
    position: 'relative',
    borderRadius: '10px !important',
    overflow: 'hidden',
    '@media (max-width: 1440px)': {
      height: '207px',
    },
    [theme.breakpoints.down('md')]: {
      height: '200px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '180px',
      borderRadius: '8px !important',
    },
    [theme.breakpoints.down('xs')]: {
      height: '160px',
      borderRadius: '6px !important',
    },
  },
  eventBannerHeadings: {
    fontSize: '0.9rem !important',
    fontWeight: '600 !important',
    margin: '10px 0px',
    color: theme.palette.KenColors.ClientBlack2,
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
    },
  },
  eventBannerHead: {
    bottom: 0,
    color: theme.palette.KenColors.kenWhite,
    fontSize: '1.1rem !important',
    fontWeight: '600 !important',
    position: 'absolute',
    margin: '20px 10px !important',
    '@media (max-width: 1440px)': {
      fontSize: '1rem !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '18px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px !important',
    },
  },
  flexContainerII: {
    display: 'flex',
    alignItems: 'center',
  },
  eventDetails: {
    display: 'flex',
    alignItems: 'start',
    gap: '30px',
  },
  accordionHeaders: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '12px !important',
    fontWeight: '400 !important',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
  },
  accordionDetailsIcon: {
    color: theme.palette.KenColors.ClientBlack1,
    height: '15px !important',
  },
  accordionRoot: {
    width: '100%',
    background: `${theme.palette.KenColors.ClientBlue} !important`,
    marginTop: '10px 0px !important',
    boxShadow: 'none !important',
  },
  accordionDetails: {
    color: theme.palette.KenColors.ClientBlack,
    fontSize: '0.9rem',
    fontWeight: '600 !important',
    paddingLeft: '10px',
    lineHeight: '18px',
  },
  accordionHead: {
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '500 !important',
    fontSize: '16px !important',
    marginRight: '20px',
    '@media (max-width: 1440px)': {
      fontSize: '0.9rem !important',
    },
    [theme.breakpoints.down('md')]: {
      height: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      height: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      height: '10px !important',
    },
  },
  topicStyle: {
    height: '10px !important',
    width: '3px',
    background: theme.palette.KenColors.ClientPrimary,
    [theme.breakpoints.down('md')]: {
      marginTop: '10px',
      height: '10px !important',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '8px',
      height: '10px !important',
    },
  },
  registeredEventsDetailsHeading: {
    fontSize: '20px !important',
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '500 !important',
    marginBottom: '10px !important',
  },
  labelText: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: `${theme.palette.KenColors.ClientBlack} !important`,
    margin: '10px 0px !important',
  },
  slotCells: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack1,
    padding: '8px !important',
    boxShadow: 'none !important',
    border: `1px solid ${theme.palette.KenColors.ClientBlue8} !important`,
    borderRadius: '4px !important',
  },
  registerText: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack1,
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '12px',
    margin: '16px 0px 0px 0px',
  },
  eventBannerDatas: {
    fontSize: '0.9rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
    },
  },
  eventDetailsContainer: {
    height: 'auto',
    overflow: 'auto',
    padding: '0px 6px 0px 0px',
    fontSize: '0.9rem !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
    },
  },
  dialogHeader: {
    fontSize: '1.1rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '1rem !important',
    },
  },
  dialogHeaderText: {
    fontSize: '0.9rem !important',
    fontWeight: '600 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
    },
  },
  speakerProfile: {
    height: '96px',
    width: '96px',
    objectFit: 'cover',
    borderRadius: '60px',
    [theme.breakpoints.down('md')]: {
      height: '90px',
      width: '90px',
    },
    [theme.breakpoints.down('sm')]: {
      height: '84px',
      width: '84px',
    },
    [theme.breakpoints.down('xs')]: {
      height: '78px',
      width: '78px',
    },
  },
  accordionTitle: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
  },
  scheduleDate: {
    background: theme.palette.KenColors.ClientBlue4,
    color: theme.palette.KenColors.ClientBlue5,
    borderRadius: '8px',
    fontSize: '12px !important',
    fontWeight: '600 !important',
    padding: '12px 24px',
    margin: '0px 10px 0px 0px',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
      padding: '9px 18px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px 20px',
      margin: '0px 8px 0px 0px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px 16px',
      margin: '0px 6px 0px 0px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
      padding: '6px 12px',
      margin: '0px 4px 0px 0px',
    },
  },
  pageHeader: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
    padding: '10px 0px 10px 0px !important',
  },
  cardContainerForm: {
    boxShadow: 'none !important',
    textAlign: 'start',
    borderRadius: '9px !important',
    paddingTop: '35px',
    paddingBottom: '35px',
    padding: '20px',
    height: '84vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
  },
  gridContainer: {
    height: '66vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: '80vh !important',
    },
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'end',
    gap: '20px',
    paddingTop: '16px',
  },
  eventResgiterFieldModal: {
    width: '40px !important',
    textAlign: 'center',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    border: `1px solid ${theme.palette.KenColors.grey} !important`,
    padding: '14px 2px !important',
    borderRadius: '8px',
  },
  eventHeaderContainer: {
    marginTop: '15px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'start',
  },
  registeredCardKey: {
    textAlign: 'start',
    fontSize: '0.9rem !important',
    color: theme.palette.KenColors.ClientBlack1,
    fontWeight: '500 !important',
    margin: '6px 0px',
    '@media (max-width: 1440px)': {
      fontSize: '0.75rem !important',
      margin: '3px 0px',
    },
  },
  eventDetailsScheduleHead: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    margin: '10px 0px',
    '@media (max-width: 1440px)': {
      fontSize: '15px !important',
    },
  },
  eventDetailsScheduleSubHead: {
    fontSize: '12px !important',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
  },
  eventRegisterBtn: {
    borderRadius: '8px !important',
    fontSize: '0.9rem !important',
    padding: '12px 18px !important',
    height: '36px',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem !important',
      padding: '9px 18px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
      padding: '10px 16px !important',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px 14px !important',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '6px 12px !important',
    },
  },
  paperCustomII: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    textAlign: 'start',
    borderRadius: '16px',
    height: '83vh',
    [theme.breakpoints.up('xxl')]: {
      height: '83.5vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
  },
  tabHeader: {
    borderBottom: `1px solid ${theme.palette.KenColors.ClientGrey3}`,
    padding: '0px 20px 0px 20px',
    '& .MuiTab-root': {
      width: '180px',
      textTransform: 'capitalize',
      color: `${theme.palette.KenColors.ClientBlack2} !important`,
      fontSize: '12px',
      fontWeight: '400',
      padding: '25px 0px 25px 0px',
      '@media (max-width: 1440px)': {
        padding: '18px 0px 18px 0px',
      },
      fontFamily: 'GeneralSans',
    },
    '& .Mui-selected': {
      fontWeight: '500 !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.KenColors.ClientBlue6,
    },
  },
  tab: {
    minWidth: '100px',
    maxWidth: '200px',
    fontSize: '12px !important',
  },
  tabPanel: {
    padding: '0px 20px',
    marginTop: 'auto',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '12px',
      marginTop: '50px',
    },
  },
  registerEventTitle: {
    fontSize: '14px !important',
    fontWeight: '600 !important',
    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  registerEventTitleType: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    '@media (max-width: 1440px)': {
      fontSize: '12px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  image: {
    width: '100%',
    height: '125px',
    '@media (max-width: 1440px)': {
      height: '126px',
    },
    objectFit: 'cover',
    borderRadius: '12px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '100px',
    },
  },
  card: {
    margin: '20px 0px',
    borderRadius: '12px',
    overflow: 'hidden',
    padding: '15px',
    background: theme.palette.KenColors.ClientBlue,
  },
  registerCardText: {
    fontSize: '0.75rem !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.65rem !important',
    },
  },
  hostEventCalendarDesc: {
    fontSize: '1rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.9rem !important',
    },
  },
  container: {
    gap: '12px',
    '@media (max-width: 1440px)': {
      gap: '9px',
    },
  },
  hostEventCalendarDesc2: {
    fontSize: '1rem !important',
    fontWeight: '400 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.9rem !important',
    },
  },
  datesChip: {
    fontSize: '0.8rem !important',
    fontWeight: '500',
    '@media (max-width: 1440px)': {
      fontSize: '0.7rem !important',
    },
  },
  rootClasses: {
    background: theme.palette.KenColors.kenWhite,
    borderRadius: '9px',
    minWidth: '20vw',
    minHeight: '20vh',
    border: '0.75px solid #7495FF',
    '@media (max-width: 1440px)': {
      minWidth: '20vw',
      minHeight: '20vh',
      borderRadius: '3px',
    },
    '& .MuiDateCalendar-root': {
      width: '100%',
    },
    '& .MuiDayCalendar-weekContainer': {
      display: 'flex',
      gap: ' 3px',
      margin: '6px 0px',
    },
    '& .MuiPickersCalendarHeader-label': {
      fontSize: '15px',
      fontWeight: '500',
      color: theme.palette.KenColors.ClientBlack,
      '@media (max-width: 1440px)': {
        fontSize: '12px',
      },
    },
    '& .MuiDayCalendar-header': {
      display: 'flex',
      gap: '3px',
      margin: '12px 0px',
      '& .MuiTypography-root': {
        color: theme.palette.KenColors.CalendarDate,
        fontSize: '12px',
        fontWeight: '500',
        '@media (max-width: 1440px)': {
          fontSize: '12px',
        },
      },
    },
    '& .MuiTypography-root.MuiDayCalendar-weekDayLabel': {
      fontSize: '12px',
      fontWeight: '400',
      '@media (max-width: 1440px)': {
        fontSize: '12px',
      },
    },
  },
  label: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack,
    margin: '10px 0px !important',
  },
  customUploadField: {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '8px',
    padding: '14px 6px',
    cursor: 'pointer',
    height: '60px',
    alignItems: 'center',
  },
  customUploadFieldText: {
    fontSize: '16px',
    fontWeight: '400 !important',
    color: theme.palette.KenColors.ClientGrey,
    margin: '0px',
    opacity: '0.9',
    paddingLeft: '8px',
  },
  dateCells: {
    borderRadius: '100px',
    padding: '6px 14px',
    fontSize: '0.9rem',
    fontWeight: '500',
    '@media (max-width: 1440px)': {
      fontSize: '0.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '4px 10px',
      fontSize: '0.75rem',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '3px 8px',
      fontSize: '0.7rem',
    },
  },
  activeDateCells: {
    background: "#E8EBF3",
    color: "#00387A",
  },
  deActiveDateCells: {
    background: theme.palette.KenColors.ClientGrey3,
    color: theme.palette.KenColors.ClientBlack2,
  },
  eventSessionConatiner: {
    background: theme.palette.KenColors.ClientBlue,
    overflowY: 'auto',
    padding: '10px',
    borderRadius: '8px',
    height: '200px',
  },
  stepLabel: {
    '& .MuiStepLabel-label': {
      fontSize: '0.9rem !important',
      fontWeight: '500 !important',
      '@media (max-width: 1440px)': {
        fontSize: '0.7rem !important',
      },
    },
    '& .Mui-active': {
      color: `${theme.palette.KenColors.ClientBlack2} !important`,
    },
  },
  stepProgress: {
    background: "#E8EBF3",
    padding: '3px 18px',
    borderRadius: '50px',
    textWrap: 'nowrap',
    fontSize: '0.8rem !important',
    fontWeight: '500',
    '@media (max-width: 1440px)': {
      fontSize: '0.7rem !important',
    },
  },
  pricingHeaders: {
    fontSize: '1rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.9rem !important',
    },
  },
  pricingDateTitle: {
    fontSize: '1.2rem !important',
    fontWeight: '500 !important',
    '@media (max-width: 1440px)': {
      fontSize: '1.1rem !important',
    },
  },
  pricingSessionTitle: {
    fontSize: '1rem !important',
    '@media (max-width: 1440px)': {
      fontSize: '0.9rem !important',
    },
  },
  eventsCardBox: {
    borderRadius: '9px !important',
    backgroundColor: '#F6F8FB',
    padding: '5px',
  },
  postJobBtns: {
    width: '100%',
    borderRadius: '6px !important',
    padding: '9px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
      padding: '5px !important',
    },
  },
}));
